'use client';
import { ButtonHTMLAttributes, startTransition } from 'react';
import { useSelectedFilters } from './useSelectedFilters';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { indentSize } from '@/uiPrimitives/layout/indentSize.definitions';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { textBlock } from '@/uiPrimitives/typography/text';
import { radioCSS } from '@/uiComposites/form/radio.css';
import { scrollToResults } from './scrollToResults';
import { useScrollTargetRef } from './FilterScrollTarget';

export const FilterClearToggle = ({
	groupKey,
	children,
	...props
}: {
	groupKey: string;
} & ButtonHTMLAttributes<HTMLButtonElement>) => {
	const [selectedFilters, navigateFilters] = useSelectedFilters();
	const count = selectedFilters.get(groupKey)?.size ?? 0;

	const scrollTargetRef = useScrollTargetRef();

	return (
		<button
			type="button"
			{...props}
			aria-pressed={count === 0}
			className={classes(shelf({}))}
			onClick={
				count > 0
					? () => {
							startTransition(() => {
								navigateFilters({
									groupKey,
									checked: false,
								});
								scrollToResults(scrollTargetRef?.current);
							});
						}
					: undefined
			}
			{...addTestSelector(`uiClearFilterGroup-${groupKey}`)}
		>
			<span
				className={classes(
					occupy({
						inlineSize: indentSize,
						justifyItems: 'start',
					}),
				)}
			>
				<span
					className={classes(
						occupy({
							blockSize: 'capSize',
						}),
					)}
				>
					<i className={classes(radioCSS)} />
				</span>
			</span>
			<span className={classes(textBlock({ color: 'positive:noHover' }))}>
				{children}
			</span>
		</button>
	);
};
